import { render, staticRenderFns } from "./HomeTabItemNew.vue?vue&type=template&id=68d3cbd6"
import script from "./HomeTabItemNew.vue?vue&type=script&lang=js"
export * from "./HomeTabItemNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports